import { createContext, useCallback, useContext, useState } from "react";
import { GET_GOOGLE_RSS_NEWS_FEED_API } from "../config/apiConfig";
import { securedFetch } from "../utils/api";

const GoogleContext = createContext();

export const GoogleProvider = ({ children }) => {
  const [googleNewsLoading, setGoogleNewsLoading] = useState(false);
  const [googleNewsError, setGoogleNewsError] = useState(null);
  const [googleNews, setGoogleNews] = useState([]);

  const fetchGoogleNewsFeedData = useCallback((query) => {
    setGoogleNewsLoading(true);
    setGoogleNewsError(null);
    securedFetch(GET_GOOGLE_RSS_NEWS_FEED_API(query), {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch the Google RSS News Feed");
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          setGoogleNews(data);
        } else {
          throw new Error("Failed to fetch the Google RSS News Feed");
        }
      })
      .catch((error) => {
        setGoogleNewsError(error.message);
        // alert(error.message);
      })
      .finally(() => {
        setGoogleNewsLoading(false);
      });
  }, []);

  return (
    <GoogleContext.Provider
      value={{
        fetchGoogleNewsFeedData,
        googleNewsLoading,
        googleNewsError,
        googleNews,
      }}
    >
      {children}
    </GoogleContext.Provider>
  );
};

export const useGoogleContext = () => useContext(GoogleContext);
